import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Avatar, IconButton } from '@mui/material';
import { Phone, PhoneDisabled, VideoCall, Mic } from '@mui/icons-material';

const IncomingCallScreen = ({ callData, onAnswer, onDecline }) => {
  const [audio] = useState(new Audio('https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3'));

  useEffect(() => {
    audio.loop = true;
    audio.play().catch(e => console.log("Audio play blocked until interaction"));
    
    return () => {
      audio.pause();
      audio.currentTime = 0;
    };
  }, [audio]);

  const { callerName, callType, incidentTitle, incidentId } = callData;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(10px)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Box sx={{ mb: 4 }}>
        <Avatar
          sx={{
            width: 120,
            height: 120,
            mb: 2,
            border: '4px solid #4caf50',
            boxShadow: '0 0 20px rgba(76, 175, 80, 0.5)',
            animation: 'pulse 2s infinite',
          }}
          src={callData.callerAvatar}
        >
          {callerName?.charAt(0)}
        </Avatar>
        <Typography variant="h4" fontWeight="bold">
          {callerName || "Unknown Caller"}
        </Typography>
        <Typography variant="subtitle1" sx={{ opacity: 0.8, mt: 1 }}>
          Incoming {callType === 'video' ? 'Video' : 'Voice'} Call
        </Typography>
      </Box>

      {incidentId && (
        <Box
          sx={{
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            padding: '10px 20px',
            borderRadius: '12px',
            mb: 6,
            maxWidth: '80%',
          }}
        >
          <Typography variant="caption" sx={{ textTransform: 'uppercase', letterSpacing: 1 }}>
            Incident Context
          </Typography>
          <Typography variant="body1" fontWeight="500">
            {incidentTitle} ({incidentId})
          </Typography>
        </Box>
      )}

      <Box sx={{ display: 'flex', gap: 6 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IconButton
            onClick={onDecline}
            sx={{
              backgroundColor: '#f44336',
              width: 80,
              height: 80,
              '&:hover': { backgroundColor: '#d32f2f' },
              mb: 1,
            }}
          >
            <PhoneDisabled sx={{ fontSize: 40, color: 'white' }} />
          </IconButton>
          <Typography variant="button">Decline</Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <IconButton
            onClick={onAnswer}
            sx={{
              backgroundColor: '#4caf50',
              width: 80,
              height: 80,
              '&:hover': { backgroundColor: '#388e3c' },
              mb: 1,
            }}
          >
            {callType === 'video' ? (
              <VideoCall sx={{ fontSize: 40, color: 'white' }} />
            ) : (
              <Phone sx={{ fontSize: 40, color: 'white' }} />
            )}
          </IconButton>
          <Typography variant="button">Answer</Typography>
        </Box>
      </Box>

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0.7); }
            70% { transform: scale(1.05); box-shadow: 0 0 0 15px rgba(76, 175, 80, 0); }
            100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(76, 175, 80, 0); }
          }
        `}
      </style>
    </Box>
  );
};

export default IncomingCallScreen;
